import { twMerge } from 'tailwind-merge';
import ListItem from '@mui/material/ListItem';
import { useScanService } from '@witmetrics/data-store';
import { formatUserName } from '@witmetrics/utils/strings';
import { formatTextDate } from '@witmetrics/utils/time';
import { isEmpty } from '@witmetrics/utils/misc';
import {
  getServiceCaseTypeId,
  getServiceTypeLabel,
} from '@witmetrics/unison-core';
import { useAppState } from '@/providers/AppStateProvider';
import Card from '@/components/Card';
import ScanServiceStatusChip from '@/components/ScanServiceStatusChip';
import TokenCountChip from '@/components/TokenCountChip';
import CaseTypeIcon from '@/components/CaseTypeIcon';
import { classes } from './utils';

export type ScanServicesListItemProps = {
  wide?: boolean;
  className?: string;
  serviceId: number;
  variant?: 'inline' | 'card';
  onOpen?: () => void;
};

export default function ScanServicesListItem({
  wide,
  className,
  serviceId,
  variant = 'inline',
  onOpen,
}: ScanServicesListItemProps) {
  const { onSelectService } = useAppState();
  const scanService = useScanService(serviceId);

  const handleSelect = () => {
    onSelectService(serviceId);
    onOpen?.();
  };

  const renderChips = () => (
    <div className={classes.chipsWrapper}>
      <ScanServiceStatusChip
        className={classes.chip}
        status={scanService!.status}
      />
      <TokenCountChip className={classes.chip} price={scanService!.price} />
    </div>
  );

  if (!scanService) return null;

  return (
    <ListItem disablePadding>
      <Card
        className={twMerge(
          variant === 'card' ? classes.cardRow : classes.row,
          className
        )}>
        <CaseTypeIcon
          className={classes.icon}
          projectTypeId={getServiceCaseTypeId(scanService.type)}
        />
        <div className={classes.content}>
          <div
            className={twMerge(
              classes.titleWrapper,
              wide && classes.titleWrapperWide
            )}>
            <button className={classes.title} onClick={handleSelect}>
              {getServiceTypeLabel(scanService)}
            </button>
            {variant === 'inline' && renderChips()}
          </div>
          <div className={classes.description}>
            {formatTextDate(scanService.createdAt)}
            {!isEmpty(scanService.createdBy) && (
              <>
                {' · '}
                {formatUserName(scanService.createdBy)}
              </>
            )}
            {' · '}
            {scanService.name}
          </div>
        </div>
        {variant === 'card' && renderChips()}
      </Card>
    </ListItem>
  );
}
